import { action, computed, makeObservable, observable } from 'mobx';

/** A flat set of selected ids. What the ids mean, and what "all" of them is, belongs to the caller. */
export default class SelectionState {
  @observable.ref public selectedIds = new Set<string>();

  public constructor() {
    makeObservable(this);
  }

  @computed
  public get selectedCount(): number {
    return this.selectedIds.size;
  }

  @computed
  public get hasSelection(): boolean {
    return this.selectedIds.size > 0;
  }

  public isSelected(id: string): boolean {
    return this.selectedIds.has(id);
  }

  public areAllSelected(ids: string[]): boolean {
    return ids.length > 0 && ids.every((id) => this.selectedIds.has(id));
  }

  public areSomeSelected(ids: string[]): boolean {
    return ids.some((id) => this.selectedIds.has(id));
  }

  @action.bound
  public select(ids: string[]): void {
    const next = new Set(this.selectedIds);
    ids.forEach((id) => next.add(id));
    this.selectedIds = next;
  }

  @action.bound
  public deselect(ids: string[]): void {
    const next = new Set(this.selectedIds);
    ids.forEach((id) => next.delete(id));
    this.selectedIds = next;
  }

  @action.bound
  public clear(): void {
    this.selectedIds = new Set();
  }
}
